/** @format */

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState, useEffect, useCallback } from "react";
import { KeywordSearch } from "mydnv/components/keyword-search";
import { PaginationControl } from "mydnv/components/pagination";
import { ConfirmOperationModal } from "mydnv/layout/full-width-myDNV/confirm-operation-modal";
import { NavLink } from "react-router-dom";
import dayjs from "dayjs";
import { Config } from "config";
import { useMyDNVContext } from "mydnv/context/mydnv-context";
import * as bookmarkService from "mydnv/services/bookmark-service";

export const BookmarksPanel = () => {
    let { instance, account, setBookmark, bookmarks } = useMyDNVContext();
    const bookmarksPerPage = 25;
    const loginRequest = Config.MyDNV.loginRequest;
    const [searchFilterText, setSearchFilterText] = useState("");
    const [filterableBookmarks, setFilterableBookmarks] = useState([]);
    const [paginationDisplayableBookmarks, setPaginationDisplayableBookmarks] = useState([]);
    const [optionsToggledBookmark, setOptionsToggledBookmark] = useState(null);

    const [modalToggleState, setModalToggleState] = useState(false);
    const [bookmarkToDelete, setBookmarkToDelete] = useState(null);
    const [parsedBookmarks, setParsedBookmarks] = useState([]);
    const [searchClicked, setSearchClicked] = useState(false);

    // const parsedBookmarks = bookmarks !== undefined ? JSON.parse(bookmarks) : [];

    useEffect(() => {
        // handleBookmarkDetailEvaluations();
        if (bookmarks !== undefined) {
            setParsedBookmarks(JSON.parse(bookmarks));
        }

        window.addEventListener("click", handleButtonClickListener);
        return () => window.removeEventListener("click", handleButtonClickListener);
    }, [bookmarks, bookmarksPerPage, setFilterableBookmarks, setPaginationDisplayableBookmarks]);

    useEffect(() => {
        let tempBmks = parsedBookmarks;
        if (searchFilterText.length > 0 && searchClicked === true) {
            tempBmks = parsedBookmarks.filter((bookmark) =>
                bookmark.title.toLowerCase().includes(searchFilterText.toLowerCase()),
            );
            setSearchClicked(false);
        }
        setFilterableBookmarks(sortedBookmarks(tempBmks));
        updatePaginationDetails(1, sortedBookmarks(tempBmks));
    }, [parsedBookmarks, searchFilterText]);

    // const handleBookmarkDetailEvaluations = useCallback((filteredBookmarks = parsedBookmarks) => {
    //     console.log(paginationDisplayableBookmarks);
    //     // let tmpBks = filteredBookmarks;
    //     // if(paginationDisplayableBookmarks.length > 0){
    //     //     tmpBks = paginationDisplayableBookmarks;
    //     // }
    //     setFilterableBookmarks(sortedBookmarks(filteredBookmarks));
    //     updatePaginationDetails(1, sortedBookmarks(filteredBookmarks));
    // }, [bookmarks]);

    const sortedBookmarks = (bmks) => {
        return [...bmks].sort((a, b) => a.order - b.order);
    };

    const openModal = (bookmark) => {
        setModalToggleState(true);
        setBookmarkToDelete(bookmark);
    };

    const closeModal = () => {
        setModalToggleState(false);
        setBookmarkToDelete(null);
    };

    const handleModal = (isDeleteRequested) => {
        if (isDeleteRequested) {
            onBookmarkDelete(bookmarkToDelete);
        }
        closeModal();
    };

    const handleBookmarkMoveUp = (bookmark) => {
        onBookmarkUpdatePosition({
            oldOrder: bookmark.order,
            newOrder: bookmark.order - 1,
        });
        setOptionsToggledBookmark(null);
    };

    const handleBookmarkMoveDown = (bookmark) => {
        onBookmarkUpdatePosition({
            oldOrder: bookmark.order,
            newOrder: bookmark.order + 1,
        });
        setOptionsToggledBookmark(null);
    };

    const handleFilterBookmarks = (searchString) => {
        setSearchClicked(true);
        setSearchFilterText(searchString);
        let filteredBookmarks = parsedBookmarks.filter((bookmark) =>
            bookmark.title.toLowerCase().includes(searchString.toLowerCase()),
        );
        setPaginationDisplayableBookmarks(sortedBookmarks(filteredBookmarks));
        // handleBookmarkDetailEvaluations(filteredBookmarks);
    };

    const clearSearchFilter = () => {
        setSearchFilterText("");
        // handleBookmarkDetailEvaluations(parsedBookmarks);
        // setPaginationDisplayableBookmarks(parsedBookmarks);
    };

    const handleResetFilterListOnEmptySearch = (searchString) => {
        if (searchString.length === 0) {
            // handleBookmarkDetailEvaluations(parsedBookmarks);
            // setPaginationDisplayableBookmarks(parsedBookmarks);
        }
    };

    // eslint-disable-next-line no-unused-vars
    const getFilteredBookmarkDate = (date) => {
        let addDate = new Date(date);
        return `${addDate.getFullYear()}-${("0" + (addDate.getMonth() + 1)).slice(
            -2,
        )}-${("0" + addDate.getDate()).slice(-2)}`;
    };

    const updatePaginationDetails = (newStartingPosition, bmks = sortedBookmarks(filterableBookmarks)) => {
        let paginationPositionLimit = newStartingPosition + bookmarksPerPage;
        setPaginationDisplayableBookmarks(
            bmks.filter(
                (bookmark) => bookmark.order + 1 >= newStartingPosition && bookmark.order + 1 < paginationPositionLimit,
            ),
        );
    };

    const openBookmarkOptionsPanel = (bookmark) => {
        if (optionsToggledBookmark === null) {
            setOptionsToggledBookmark(bookmark);
        } else {
            setOptionsToggledBookmark(null);
        }
    };

    const isToggledBookmark = (bookmark) => {
        return optionsToggledBookmark !== null && optionsToggledBookmark.guid === bookmark.guid;
    };

    const handleButtonClickListener = (event) => {
        let openOptionsMenuElement = Array.from(document.getElementsByClassName("bookmarkOptions show"));
        let optionsButtonElement = Array.from(document.getElementsByClassName("openBookmarkOptionsPanel"));

        if (
            optionsButtonElement.length > 0 &&
            !optionsButtonElement.some((element) => element.contains(event.target)) &&
            openOptionsMenuElement.length > 0 &&
            !openOptionsMenuElement[0].contains(event.target)
        ) {
            setOptionsToggledBookmark(null);
        }
    };

    // eslint-disable-next-line no-unused-vars
    const convertUTCDateToLocalDate = (date) => {
        var newDate = new Date(date.getTime() + date.getTimezoneOffset() * 60 * 1000);
        var offset = date.getTimezoneOffset() / 60;
        var hours = date.getHours();
        newDate.setHours(hours - offset);
        return newDate;
    };

    const formatDateForDisplay = (dateStr) => {
        let date = new Date(dateStr);
        let localConvertedDate = dayjs(date).utc(true).local().format("YYYY-MM-DD");
        // let displayDate = getFilteredBookmarkDate(localConvertedDate);
        return localConvertedDate;
    };

    const runApiCall = useCallback(
        (callback, ...args) => {
            const request = {
                ...loginRequest,
                account: account,
            };

            instance
                .acquireTokenSilent(request)
                .then((response) => {
                    if (args.length > 0) {
                        callback(response.accessToken, ...args);
                    } else {
                        callback(response.accessToken);
                    }
                })
                .catch((e) => {
                    console.error(e);
                });
        },
        [account, instance, loginRequest],
    );

    const postBookmarkDeletion = async (token, webpage) => {
        let response = await bookmarkService.deleteBookmark({ token, webpage });
        setBookmark(JSON.stringify(response.data));
    };

    const onBookmarkDelete = (bookmark) => {
        let bookmarkIndex = paginationDisplayableBookmarks.findIndex(
            (bookmarkEntry) => bookmarkEntry.guid === bookmark.guid,
        );
        let bookmarkToDelete = paginationDisplayableBookmarks[bookmarkIndex];

        let bookmarkOldPosition = bookmark.order;
        let bookmarksToUpdate = [
            ...paginationDisplayableBookmarks.slice(0, bookmarkIndex),
            ...paginationDisplayableBookmarks.slice(bookmarkIndex + 1, paginationDisplayableBookmarks.length),
        ].map((bookmarkEntry) => ({
            ...bookmarkEntry,
            order: bookmarkEntry.order > bookmarkOldPosition ? bookmarkEntry.order - 1 : bookmarkEntry.order,
        }));

        runApiCall(postBookmarkDeletion, bookmarkToDelete);
        // setBookmarks(bookmarksToUpdate);
        setSearchClicked(true);
        setPaginationDisplayableBookmarks(bookmarksToUpdate);
    };

    const putBookmarkPositionUpdate = async (token, positionChanges) => {
        let response = await bookmarkService.updateBookmarkPosition({
            token,
            positionChanges,
        });
        setBookmark(JSON.stringify(response.data));
    };
    const onBookmarkUpdatePosition = (positionChanges) => {
        // let bookmarksToUpdate = [...paginationDisplayableBookmarks];
        // use full set  in case filter is applied and top of list isn't #1 or bottom list isn't last
        let bookmarksToUpdate = [...parsedBookmarks];
        let oldBookmarkEntryIndex = bookmarksToUpdate.findIndex(
            (bookmark) => bookmark.order === positionChanges.oldOrder,
        );
        let newBookmarkEntryIndex = bookmarksToUpdate.findIndex(
            (bookmark) => bookmark.order === positionChanges.newOrder,
        );

        bookmarksToUpdate[oldBookmarkEntryIndex].order = positionChanges.newOrder;
        bookmarksToUpdate[newBookmarkEntryIndex].order = positionChanges.oldOrder;

        // filter again after positions changed
        if (searchFilterText.length > 0) {
            bookmarksToUpdate = bookmarksToUpdate.fill((b) =>
                b.title.toLowerCase().includes(searchFilterText.toLowerCase()),
            );
        }
        setSearchClicked(true);
        runApiCall(putBookmarkPositionUpdate, positionChanges);
        // setBookmarks(bookmarksToUpdate);
        setPaginationDisplayableBookmarks(bookmarksToUpdate);
    };

    return (
        <>
            <div className="bookmarksPanelCard">
                <div className="cardRow">
                    {parsedBookmarks.length === 0 && (
                        <div className="noContentSaved">
                            <span>Pages you bookmark will appear here.</span>
                        </div>
                    )}

                    {parsedBookmarks.length > 0 && (
                        <>
                            <KeywordSearch
                                inputValue={searchFilterText}
                                onInputChange={(e) => {
                                    setSearchFilterText(e.target.value);
                                    // handleResetFilterListOnEmptySearch(e.target.value);
                                }}
                                onClearSearchFilter={clearSearchFilter}
                                onFilterContent={handleFilterBookmarks}
                                displayableItemsLength={paginationDisplayableBookmarks.length}
                                totalItemsLength={paginationDisplayableBookmarks.length}
                            />

                            {paginationDisplayableBookmarks.length === 0 && (
                                <div className="noBookmarks">Pages you bookmark will appear here.</div>
                            )}

                            {paginationDisplayableBookmarks.length > 0 && (
                                <>
                                    <div className="bookmarksTableMobile">
                                        {paginationDisplayableBookmarks.map((bookmark) => {
                                             if (bookmark.title !== undefined) {
                                                return (
                                                <div className="bookmarksTableDataRow" key={bookmark.guid}>
                                                    <div className="cardLeftContent">
                                                        <div className="pageRow">
                                                            <NavLink to={bookmark.path}>{bookmark.title}</NavLink>
                                                        </div>

                                                        <div className="dateUpdatedRow">
                                                            Updated: {formatDateForDisplay(bookmark.updated_Date)}
                                                        </div>

                                                        <div className="dateAddedRow">
                                                            Date added: {formatDateForDisplay(bookmark.created_Date)}
                                                        </div>
                                                    </div>

                                                    <div className="cardRightContent">
                                                        <div className="bookmarkBtns">
                                                            <div className="removeBookmarkBtn">
                                                                <button onClick={() => openModal(bookmark)}>
                                                                    <span>
                                                                        <FontAwesomeIcon icon="fas fa-trash-alt" />
                                                                    </span>
                                                                </button>
                                                            </div>

                                                            <div className="moveUpBtn">
                                                                <button
                                                                    onClick={() => handleBookmarkMoveUp(bookmark)}
                                                                    disabled={bookmark.order === 0}
                                                                >
                                                                    <span>
                                                                        <FontAwesomeIcon icon="fas fa-arrow-up" />
                                                                    </span>
                                                                </button>
                                                            </div>

                                                            <div className="moveDownBtn">
                                                                <button
                                                                    onClick={() => handleBookmarkMoveDown(bookmark)}
                                                                    disabled={parsedBookmarks.every(
                                                                        (entry) => bookmark.order >= entry.order,
                                                                    )}
                                                                >
                                                                    <span>
                                                                        <FontAwesomeIcon icon="fas fa-arrow-down" />
                                                                    </span>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                )
                                            }})
                                        }
                                    </div>

                                    <div className="bookmarksTable">
                                        <div className="bookmarksTableHeader">
                                            <div className="positionCol">Position</div>
                                            <div className="PageCol">Page</div>
                                            <div className="DateAddedCol">Date added</div>
                                            <div className="extraActionsCol"></div>
                                        </div>

                                        {paginationDisplayableBookmarks.map((bookmark) => {
                                            if (bookmark.title !== undefined) {
                                                return (
                                                    <div className="bookmarksTableDataRow" key={bookmark.guid}>
                                                        <div className="positionCol">#{bookmark.order + 1}</div>
                                                        <div className="PageCol">
                                                            <NavLink to={bookmark.path}>{bookmark.title}</NavLink>
                                                        </div>
                                                        <div className="DateAddedCol">
                                                            {formatDateForDisplay(bookmark.created_Date)}
                                                        </div>
                                                        <div className="extraActionsCol">
                                                            <button
                                                                className="openBookmarkOptionsPanel"
                                                                onClick={() => openBookmarkOptionsPanel(bookmark)}
                                                            >
                                                                <FontAwesomeIcon icon="fas fa-ellipsis-v" />
                                                            </button>

                                                            <div
                                                                className={`bookmarkOptions ${
                                                                    isToggledBookmark(bookmark) ? "show" : ""
                                                                }`}
                                                            >
                                                                <button
                                                                    className="removeBookmarkButton"
                                                                    onClick={() => openModal(bookmark)}
                                                                >
                                                                    Remove
                                                                    <span>
                                                                        <FontAwesomeIcon icon="fas fa-trash-alt" />
                                                                    </span>
                                                                </button>

                                                                <button
                                                                    onClick={() => handleBookmarkMoveUp(bookmark)}
                                                                    disabled={bookmark.order === 0}
                                                                >
                                                                    Move up
                                                                    <span>
                                                                        <FontAwesomeIcon icon="fas fa-arrow-up" />
                                                                    </span>
                                                                </button>

                                                                <button
                                                                    onClick={() => handleBookmarkMoveDown(bookmark)}
                                                                    disabled={parsedBookmarks.every(
                                                                        (entry) => bookmark.order >= entry.order,
                                                                    )}
                                                                >
                                                                    Move down
                                                                    <span>
                                                                        <FontAwesomeIcon icon="fas fa-arrow-down" />
                                                                    </span>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                );
                                            }
                                        })}
                                    </div>

                                    <PaginationControl
                                        contentPerPage={bookmarksPerPage}
                                        totalContentLength={parsedBookmarks.length}
                                        onPaginationUpdate={updatePaginationDetails}
                                    />
                                </>
                            )}
                        </>
                    )}
                </div>
            </div>

            <ConfirmOperationModal
                isOpen={modalToggleState}
                setModalOpen={handleModal}
                headerText="Remove this bookmark?"
                paragraphText="You can add it back anytime by selecting the bookmark button on the page again."
                okButtonText="Yes, remove"
            />
        </>
    );
};
